import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Paper, TextField, Button, Typography, Container, Alert, CircularProgress } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import apiClient from '../../services/apiClient';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiClient.requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <Paper sx={{ p: 4 }}>
          {sent ? (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Check Your Email</Typography>
              <Typography color="text.secondary" sx={{ mb: 3 }}>
                If <strong>{email}</strong> is registered, you'll receive a password reset link within a few minutes. The link expires in 30 minutes.
              </Typography>
              <Button component={Link} to="/login" startIcon={<ArrowBack />}>Back to Login</Button>
            </Box>
          ) : (
            <>
              <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Forgot Password</Typography>
              <Typography color="text.secondary" sx={{ mb: 3 }}>
                Enter your email address and we'll send you a link to reset your password.
              </Typography>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth label="Email" type="email"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  margin="normal" required autoComplete="email"
                />
                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </Button>
              </form>
              <Box sx={{ textAlign: 'center' }}>
                <Button component={Link} to="/login" startIcon={<ArrowBack />} size="small">Back to Login</Button>
              </Box>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
